import React, { useState, useEffect } from "react";

import {
  Box,
  Typography,
  TextField,
  Grid,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  CircularProgress,
  IconButton,
  FormHelperText,
} from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import { DesktopDatePicker } from "@mui/x-date-pickers/DesktopDatePicker";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { parseISO } from "date-fns";

import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";

import {
  getEmployees,
  deleteEmployee,
  createEmployee,
  updateEmployee,
  getEmployeeList,
} from "../../api/employee";
import { handleAxiosError } from "../../config/action-config";

import {
  ticketsTable as tableDef,
  userProjectTable,
} from "../../config/grid-columns-defs";
import ControlledTable from "../../component/ControlledTable";
import DeleteAlertDialog from "../../component/DeleteAlertDialog";
import UpdateDialog from "../../component/UpdateDialog";
import { showAlert } from "../../actions/alert";
import { createTicket, getTickets } from "../../api/ticket";
import { getCustomerList } from "../../api/customer";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { useForm, Controller } from "react-hook-form";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import dayjs from "dayjs";
import { TicketFormatter } from "../../config/grid-value-formatters";
import { makeStyles } from "@material-ui/core";
import { useMediaQuery } from "@mui/material";
const useStyles = makeStyles((theme) => ({
  textfeild: {
    "& .MuiFilledInput-root": {
      color: "#fff !important",
    },
  },
}));

const emptyUpdateData = {
  email: "",
  firstname: "",
  lastname: "",
  address: "",
  contact: "",
  role: "",
  cost_rate: "",
  bill_rate: "",
};

export default function Tickets() {
  const classes = useStyles();
  const user = useSelector((state) => state.user);
  const dialogAction = useSelector((state) => state.dialog);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [totalCount, setTotalCount] = useState(0);
  const [rows, setRows] = useState([]);
  const [pageNumber, setPageNumber] = useState(0);
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [updateDialogOpen, setUpdateDialogeOpen] = useState(false);
  const [createDialogOpen, setCreateDialogOpen] = useState(false);
  const [deleteId, setDeleteId] = useState(-1);
  const [updateId, setUpdateId] = useState(-1);
  const [updateData, setUpdateData] = useState(emptyUpdateData);
  const [newTicketData, setNewTicketData] = useState(emptyNewTicketData);
  const startDate = new Date();
  const [ticketId, setTicketId] = useState("");
  let removeTicket = tableDef.find((o) => o.headerName === "Ticket");
  if (user.role === "Customer" || user.role === "Subcustomer") {
  } else {
    if (removeTicket === undefined) {
      tableDef.push({
        headerName: "Ticket",
        field: "flag",
        resizable: true,
        minWidth: 70,
        cellStyle: { fontSize: "11px", alignItems: "flex-start" },
        wrapText: true,
        autoHeight: true,

        valueFormatter: TicketFormatter,
      });
    }
  }
  let obj = tableDef.find((o) => o.headerName === "Action");
  if (obj === undefined) {
    tableDef.unshift({
      headerName: "Action",
      field: "actions",
      minWidth: 65,
      maxWidth: 70,
      headerClass: "justify-center",
      cellClass: "justify-center",
      cellStyle: { alignItems: "flex-start" },
      resizable: true,
      wrapText: true,
      autoHeight: true,
      cellStyle: { fontSize: "11px", lineHeight: "20px" },

      cellRendererFramework: (params) => (
        <IconButton
          color="info"
          onClick={() => {
            dispatch({ type: "VIEW", data: params.data });
          }}
        >
          <VisibilityIcon fontSize="inherit" />
        </IconButton>
      ),
    });
  }

  const onNewTicketSubmit = async (data) => {
    try {
      // const { data } = await createTicket(newTicketData, user.token);
      dispatch(showAlert(data.msg));
      setNewTicketData(emptyNewTicketData);
      refreshTable();
      setCreateDialogOpen(false);
    } catch (err) {
      handleAxiosError(err, dispatch);
      setCreateDialogOpen(false);
    }
  };

  useEffect(() => {
    refreshTable();
  }, [ticketId]);
  const refreshTable = async () => {
    try {
      const { data } = await getTickets(
        { ticketid: ticketId, limit: 10, offset: 0 },
        user.token
      );

      setTotalCount(
        parseInt(data.data.total) === 0 ? -1 : parseInt(data.data.total)
      );
      setRows(data.data.records);
    } catch (err) {
      handleAxiosError(err, dispatch);
    }
  };

  useEffect(() => {
    if (!dialogAction.type) return;
    switch (dialogAction.type) {
      case "EDIT": {
        setUpdateDialogeOpen(true);
        const up = getUpdatableData(dialogAction.data);
        setUpdateData(up);
        break;
      }
      case "DELETE":
        setDeleteDialogOpen(true);
        break;
      case "VIEW":
        dispatch({ type: "" });
        navigate(`${dialogAction.data.id}`);
        break;
      default:
        break;
    }
  }, [dialogAction]);

  useEffect(() => {
    if (deleteId === -1) return;
    deleteEmployee(deleteId, user.token)
      .then((res) => {
        dispatch(showAlert(res.data.msg));
        setDeleteId(-1);
        refreshTable();
        setDeleteDialogOpen(false);
      })
      .catch((err) => {
        handleAxiosError(err, dispatch);
        setDeleteId(-1);
        setDeleteDialogOpen(false);
      });
  }, [deleteId]);

  useEffect(() => {
    if (updateId === -1) return;
    updateEmployee(updateId, updateData, user.token)
      .then((res) => {
        dispatch(showAlert(res.data.msg));
        setUpdateId(-1);
        setUpdateData(emptyUpdateData);
        refreshTable();
        setUpdateDialogeOpen(false);
      })
      .catch((err) => {
        handleAxiosError(err, dispatch);
        setUpdateId(-1);
        setUpdateDialogeOpen(false);
      });
  }, [updateId]);

  const getRows = async (numRows, startRow) => {
    return getTickets(
      { email: user.email, limit: numRows, offset: startRow },
      user.token
    )
      .then((res) => {
        setTotalCount(
          parseInt(res.data.data.total) === 0 ? -1 : res.data.data.total
        );
        return res.data.data.records;
      })
      .catch((err) => {
        handleAxiosError(err, dispatch);
        return [];
      });
  };

  const changeUpdateData = (e) => {
    setUpdateData((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };
  const changeNewEmployeeData = (e) => {
    setNewTicketData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };
  const isFullWidth = useMediaQuery((theme) => theme.breakpoints.only("xs"));
  return (
    <Box className="pmt-container-box">
      {/* <Box className="pmt-title-box">
        <Box className="typography-title">
          <Typography>Tickets</Typography>
        </Box>

        <Button
          variant="contained"
          style={{ padding: "5px 7px" }}
          onClick={() => {
            setCreateDialogOpen(true);
          }}
          className="blue-button"
        >
          Add Ticket
        </Button>
      </Box> 
      <br />*/}
      <Box className="pmt-filter-box" style={{display:"grid",width:"100%",justifyContent:"normal"}}>
          <Box sx={{ mb: 2 }}>
                <Typography variant="h1" className="pmt-headings-h1">
                Tickets
                </Typography>
              </Box>
        <Grid
          container
          className="report-filter-box"
          style={{display:"flex",width:"100%"}}
          rowSpacing={1}
          columnSpacing={{ xs: 1, sm: 1, md: 1 }}
        >
          <Grid item md={2} sm={4} xs={12}>
            <TextField
              className={classes.textfeild}
              id="demo-simple-select"
              value={ticketId}
              fullWidth
              label="Ticket Id"
              size="small"
              onChange={(e) => {
                setTicketId(e.target.value);
              }}
            />
          </Grid>
          <Grid item md={10} sm={8} xs={12}>
            <Button
              variant="contained"
              style={{ padding: "5px 7px" }}
              onClick={() => {
                setCreateDialogOpen(true);
              }}
              className="light-button float-right"
              fullWidth={isFullWidth}
            >
              Add Ticket
            </Button>
          </Grid>
        </Grid>
      </Box>
      <div className="pmt-controll-table">
        <ControlledTable
          rows={rows}
          columnDefs={tableDef}
          getRows={getRows}
          totalCount={totalCount}
          onChange={setRows}
          onPageNumberChange={setPageNumber}
          pageSize={10}
          pageNumber={pageNumber}
          pagination={true}
          // getRowNodeId={(data) => data?.name || data?.index}
          hasActionButtons={false}
        />
      </div>
      <DeleteAlertDialog
        open={deleteDialogOpen}
        setOpen={setDeleteDialogOpen}
        setDeleteId={setDeleteId}
        rowId={dialogAction.data?.id}
      />
      <UpdateDialog
        open={updateDialogOpen}
        setOpen={setUpdateDialogeOpen}
        setUpdateId={setUpdateId}
        rowId={dialogAction.data?.id}
      >
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6} md={6}>
            <TextField
              margin="dense"
              name="email"
              fullWidth
              value={updateData.email}
              onChange={changeUpdateData}
              label="Email"
              type="email"
              variant="outlined"
            />
          </Grid>
          <Grid item xs={12} sm={6} md={6}>
            <TextField
              margin="dense"
              name="firstname"
              fullWidth
              value={updateData.firstname}
              onChange={changeUpdateData}
              label="First Name"
              className="name-textfeild"
              type="text"
              variant="outlined"
            />
          </Grid>
          <Grid item xs={12} sm={6} md={6}>
            <TextField
              margin="dense"
              name="lastname"
              fullWidth
              value={updateData.lastname}
              onChange={changeUpdateData}
              label="Last Name"
              className="name-textfeild"
              type="text"
              variant="outlined"
            />
          </Grid>
          <Grid item xs={12} sm={6} md={6}>
            <TextField
              margin="dense"
              name="contact"
              fullWidth
              value={updateData.contact}
              error={!/^[0-9]{10}$/.test(updateData.contact)}
              inputProps={{ maxLength: 10 }}
              onChange={changeUpdateData}
              label="Contact"
              type="tel"
              variant="outlined"
            />
          </Grid>
          <Grid item xs={12} sm={6} md={6}>
            <TextField
              margin="dense"
              name="role"
              fullWidth
              value={updateData.role}
              onChange={changeUpdateData}
              label="Role"
              type="text"
              variant="outlined"
            />
          </Grid>
          <Grid item xs={12} sm={6} md={6}>
            <TextField
              margin="dense"
              name="bill_rate"
              fullWidth
              value={updateData.bill_rate}
              onChange={changeUpdateData}
              label="Bill Rate"
              type="number"
              variant="outlined"
            />
          </Grid>
          <Grid item xs={12} sm={6} md={6}>
            <TextField
              margin="dense"
              name="cost_rate"
              fullWidth
              value={updateData.cost_rate}
              onChange={changeUpdateData}
              label="Cost Rate"
              type="number"
              variant="outlined"
            />
          </Grid>
          <Grid item xs={12} md={12}>
            <TextField
              margin="dense"
              name="address"
              fullWidth
              value={updateData.address}
              onChange={changeUpdateData}
              label="Address"
              type="text"
              variant="outlined"
            />
          </Grid>
        </Grid>
      </UpdateDialog>

      <AddTicketDialog
        open={createDialogOpen}
        setOpen={setCreateDialogOpen}
        onSubmit={onNewTicketSubmit}
        onRefresh={refreshTable}
      />
    </Box>
  );
}

const emptyNewTicketData = {
  customer_id: "",
  severity: "LOW",
  status: "OPEN",
  type: "",
  flag: "E",
  problem: "",
  downtime_from: "",
  downtime_to: "",
  due_date: "",
  problem_description: "",
  assigned: "",
};

function AddTicketDialog({ open, setOpen, onSubmit, onRefresh }) {
  const [showLoader, setShowLoader] = useState(false);
  const user = useSelector((state) => state.user);
  const [data, setData] = useState(emptyNewTicketData);
  const [customersList, setCustomersList] = useState([]);
  const [employeesList, setEmployeesList] = useState([]);
  const [assign, setAssignTo] = useState("");
  const [flag, setFlag] = useState("E");
  const [minDate, setMinDate] = useState("");
  const [maxDate, setMaxDate] = useState("");
  const [maxDueDate, setMaxDueDate] = useState("");

  const {
    register,
    getValues,
    handleSubmit,
    control,
    reset,
    formState: { errors },
  } = useForm({ defaultValues: emptyNewTicketData });

  const dispatch = useDispatch();
  useEffect(() => {
    if (open) {
      setData(emptyNewTicketData);
      customerList();
      employeeList();
    }
  }, [open]);

  const onInputChange = ({ target }) => {
    setData((prev) => ({ ...prev, [target.name]: target.value }));
  };

  const onNewTicketSubmit = (data) => {
    data.downtime_to =
      data.downtime_to === "" ? "" : createDateAsUTC(data.downtime_to);
    data.downtime_from =
      data.downtime_from === "" ? "" : createDateAsUTC(data.downtime_from);
    data.due_date = data.due_date === "" ? "" : createDateAsUTC(data.due_date);
    switch (user.role) {
      case "Customer":
        {
          data.flag = "E";
          data.customer_id = user.roleId;
        }
        break;
      case "Subcustomer":
        {
          data.flag = "E";
        }
        break;
      default:
        break;
    }

    try {
      createTicket(data, user.token).then((res) => {
        setMinDate("");
        setMaxDate("");
        dispatch(showAlert(res.data.msg));
        setData(emptyNewTicketData);
        setOpen(false);
        onRefresh();
      });
    } catch (err) {
      handleAxiosError(err, dispatch);
      setOpen(false);
    }
  };
  const [selectedCustomerName, setSelectedCustomerName] = useState("");
  const customerList = async () => {
    const token = user.token;
    return await getCustomerList(token).then((res) => {
      setCustomersList(res.data.data);
      if (user.role === "Customer") {
        let customer = res.data.data.find((e) => e.id === user.roleId);
        setSelectedCustomerName(customer.company_name);
      }
    });
  };

  const employeeList = async () => {
    const token = user.token;
    return await getEmployeeList(token).then((res) => {
      setEmployeesList(res.data.EmployeeList);
    });
  };

  return (
    <Dialog
      open={open}
      onClose={() => {
        // setOpen(false);
      }}
    >
      <DialogTitle>Create New Ticket</DialogTitle>
      <Box component="form" onSubmit={onNewTicketSubmit}>
        <DialogContent>
          {/* {showLoader ? (
            <>
              <br />
              <CircularProgress />
            </>
          ) : (
            <></>
          )}
          <br /> */}
          <form onSubmit={handleSubmit(onNewTicketSubmit)}>
            <Grid container spacing={2} className="newTicketTextfield">
              <Grid item xs={12} md={6} sm={6}>
                {
                  user.role === "Customer" ? (
                    <TextField
                      value={selectedCustomerName}
                      //labelChange
                      label="Customer Name"
                      required
                      fullWidth
                      name="customer_id"
                      disabled
                      margin="dense"
                      inputRef={register({
                        required: "Customer is required.",
                      })}
                      error={Boolean(errors.customer_id)}
                      helperText={errors.customer_id?.message}
                    />
                  ) : (
                    <FormControl
                      fullWidth
                      margin="dense"
                      error={Boolean(errors.customer_id)}
                      required
                    >
                      <InputLabel id="demo-simple-select-label">
                        {/* Company Name */}
                        Customer
                      </InputLabel>

                      <Controller
                        render={(props) => (
                          <Select
                            MenuProps={{ className: "select-box-height" }}
                            value={props.value}
                            onChange={props.onChange}
                          >
                            {customersList.map((c, i) => (
                              <MenuItem key={i} value={c.id}>
                                {c.company_name}
                              </MenuItem>
                            ))}
                          </Select>
                        )}
                        name="customer_id"
                        control={control}
                        // defaultValue=""
                        rules={{
                          required: "Please select Customer",
                        }}
                      />
                      <FormHelperText>
                        {errors.customer_id?.message}
                      </FormHelperText>
                    </FormControl>
                  )
                  //   </Select>
                  // </FormControl>
                }
              </Grid>
              <Grid item xs={12} md={6} sm={6}>
                <FormControl
                  fullWidth
                  margin="dense"
                  error={Boolean(errors.severity)}
                >
                  <InputLabel id="demo-simple-select-label">
                    Severity
                  </InputLabel>
                  <Controller
                    render={(props) => (
                      <Select
                        MenuProps={{ className: "select-box-height" }}
                        // disabled
                        value={props.value}
                        onChange={props.onChange}
                      >
                        <MenuItem value="HIGH">HIGH</MenuItem>
                        <MenuItem value="LOW">LOW</MenuItem>
                        <MenuItem value="MEDIUM">MEDIUM</MenuItem>
                      </Select>
                    )}
                    name="severity"
                    label="Severity"
                    control={control}
                    // defaultValue=""
                    rules={{
                      required: "Please select severity",
                    }}
                  />
                  <FormHelperText>{errors.severity?.message}</FormHelperText>
                </FormControl>
              </Grid>
              <Grid item xs={12} md={6} sm={6}>
                <FormControl fullWidth error={Boolean(errors.status)}>
                  <InputLabel id="demo-simple-select-label">Status</InputLabel>
                  <Controller
                    render={(props) => (
                      <Select
                        value={props.value}
                        onChange={props.onChange}
                        disabled
                      >
                        <MenuItem value="CLOSED">CLOSED</MenuItem>
                        <MenuItem value="OPEN">OPEN</MenuItem>

                        <MenuItem value="WORK IN PROGRESS">
                          WORK IN PROGRESS
                        </MenuItem>
                      </Select>
                    )}
                    name="status"
                    control={control}
                    // defaultValue=""
                    rules={{
                      required: "Please select status",
                    }}
                  />
                  <FormHelperText>{errors.status?.message}</FormHelperText>
                </FormControl>
              </Grid>
              <Grid item xs={12} md={6} sm={6}>
                <FormControl required fullWidth error={Boolean(errors.type)}>
                  <InputLabel id="demo-simple-select-label">Type</InputLabel>
                  <Controller
                    render={(props) => (
                      <Select
                        value={props.value}
                        onChange={props.onChange}
                        MenuProps={{ className: "select-box-height" }}
                      >
                        <MenuItem value="">Select</MenuItem>
                        <MenuItem value="ACCOUNT ISSUE">Account Issue</MenuItem>
                        <MenuItem value="INCIDENT">Incident</MenuItem>
                        <MenuItem value="OTHER">Other</MenuItem>
                        <MenuItem value="PROBLEM">Problem</MenuItem>
                        <MenuItem value="QUESTION">Question</MenuItem>
                        <MenuItem value="TASK">Task</MenuItem>
                        <MenuItem value="USAGE PROBLEM">Usage Problem</MenuItem>
                      </Select>
                    )}
                    name="type"
                    control={control}
                    // defaultValue=""
                    rules={{
                      required: "Please select type",
                    }}
                  />
                  <FormHelperText>{errors.type?.message}</FormHelperText>
                </FormControl>
                {/* <FormControl required fullWidth>
                  <InputLabel id="demo-simple-select-label-t">Type</InputLabel>
                  <Select
                    labelId="demo-simple-select-label-t"
                    id="demo-simple-select-t"
                    value={data.type}
                    label="Type"
                    name="type"
                    onChange={onInputChange}
                  >
                    <MenuItem value="">Select</MenuItem>
                    <MenuItem value="INCIDENT">Incident</MenuItem>
                    <MenuItem value="QUESTION">Question</MenuItem>
                    <MenuItem value="PROBLEM">Problem</MenuItem>
                    <MenuItem value="TASK">Task</MenuItem>
                    <MenuItem value="ACCOUNT ISSUE">Account Issue</MenuItem>
                    <MenuItem value="USAGE PROBLEM">Usage Problem</MenuItem>
                    <MenuItem value="OTHER">Other</MenuItem>
                  </Select>
                </FormControl> */}
              </Grid>

              <Grid item xs={12} md={6} sm={6}>
                <TextField
                  name="problem"
                  fullWidth
                  // value={newProjectData.project_name}
                  // onChange={changeNewProjectData}
                  label="Subject"
                  type="text"
                  variant="outlined"
                  inputRef={register({
                    required: "Subject is required.",
                  })}
                  required
                  error={Boolean(errors.problem)}
                  helperText={errors.problem?.message}
                />
                {/* <TextField
                  name="problem"
                  value={data.problem}
                  onChange={onInputChange}
                  required
                  fullWidth
                  label="Subject"
                /> */}
              </Grid>
              <Grid item xs={12} md={6} sm={6}>
                <FormControl
                  required
                  fullWidth
                  error={Boolean(errors.due_date)}
                >
                  <LocalizationProvider dateAdapter={AdapterDateFns}>
                    <Controller
                      render={(props) => (
                        <DesktopDatePicker
                          value={props.value || ""}
                          shouldDisableDate={
                            minDate || maxDate === ""
                              ? disablePrevDates(
                                  dayjs(new Date()).subtract(1, "days").toJSON()
                                )
                              : false
                          }
                          maxDate={maxDate}
                          minDate={minDate}
                          label="Due Date"
                          onChange={(nv) => {
                            props.onChange(nv);
                            setMaxDueDate(nv);
                          }}
                          renderInput={(params) => (
                            <TextField
                              // FormHelperTextProps={{
                              //   className: classes.helperText,
                              // }}
                              error={Boolean(errors.due_date)}
                              {...params}
                              required
                            />
                          )}
                        />
                      )}
                      rules={{
                        required: "Due date to is required.",
                      }}
                      name="due_date"
                      control={control}
                    />
                  </LocalizationProvider>
                  <FormHelperText>{errors.due_date?.message}</FormHelperText>
                  {/* <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DesktopDatePicker
                      label="Due Date"
                      shouldDisableDate={disablePrevDates(new Date())}
                      value={parseISO(data.due_date)}
                      onChange={(nv) => {
                        onInputChange({
                          target: {
                            name: "due_date",
                            value: new Date(nv).toISOString(),
                          },
                        });
                      }}
                      renderInput={(params) => (
                        <TextField required {...params} />
                      )}
                    />
                  </LocalizationProvider> */}
                </FormControl>
              </Grid>
              <Grid item xs={12} md={6} sm={6}>
                <FormControl fullWidth error={Boolean(errors.downtime_from)}>
                  <LocalizationProvider dateAdapter={AdapterDateFns}>
                    <Controller
                      render={(props) => (
                        <DateTimePicker
                          value={props.value || ""}
                          label="Downtime From"
                          minDate={disablePrevDates(
                            dayjs(new Date()).subtract(1, "days").toJSON()
                          )}
                          maxDate={maxDueDate}
                          shouldDisableDate={disablePrevDates(
                            dayjs(new Date()).subtract(1, "days").toJSON()
                          )}
                          onChange={(nv) => {
                            props.onChange(nv);
                            setMinDate(nv);
                          }}
                          // onChange={props.onChange}
                          renderInput={(params) => <TextField {...params} />}
                        />
                      )}
                      rules={{
                        required: false,
                        // minDate || maxDate !== ""
                        //   ? "Downtime from is required"
                        //   : false,
                      }}
                      name="downtime_from"
                      control={control}
                    />
                  </LocalizationProvider>
                  <FormHelperText>
                    {errors.downtime_from?.message}
                  </FormHelperText>
                  {/* <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DateTimePicker
                      label="Downtime From"
                      value={parseISO(data.downtime_from)}
                      onChange={(nv) => {
                        onInputChange({
                          target: {
                            name: "downtime_from",
                            value: new Date(nv).toISOString(),
                          },
                        });
                      }}
                      renderInput={(params) => (
                        <TextField required {...params} />
                      )}
                    />
                  </LocalizationProvider> */}
                </FormControl>
              </Grid>
              <Grid item xs={12} md={6} sm={6}>
                <FormControl fullWidth error={Boolean(errors.downtime_to)}>
                  <LocalizationProvider dateAdapter={AdapterDateFns}>
                    <Controller
                      render={(props) => (
                        <DateTimePicker
                          value={props.value || ""}
                          label="Downtime To"
                          minDate={disablePrevDates(
                            dayjs(new Date()).subtract(1, "days").toJSON()
                          )}
                          maxDate={maxDueDate}
                          shouldDisableDate={disablePrevDates(
                            dayjs(new Date(minDate))
                              .subtract(1, "days")
                              .toJSON()
                          )}
                          onChange={(nv) => {
                            props.onChange(nv);
                            setMaxDate(nv);
                          }}
                          renderInput={(params) => <TextField {...params} />}
                        />
                      )}
                      rules={{
                        required: false,
                        // minDate || maxDate !== ""
                        //   ? "Downtime to is required"
                        //   : false,
                      }}
                      name="downtime_to"
                      control={control}
                    />
                  </LocalizationProvider>
                  <FormHelperText>{errors.downtime_to?.message}</FormHelperText>
                  {/* <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DateTimePicker
                      label="Downtime To"
                      value={parseISO(data.downtime_to)}
                      shouldDisableDate={disablePrevDates(
                        parseISO(data.downtime_from)
                      )}
                      onChange={(nv) => {
                        onInputChange({
                          target: {
                            name: "downtime_to",
                            value: new Date(nv).toISOString(),
                          },
                        });
                      }}
                      renderInput={(params) => (
                        <TextField required {...params} />
                      )}
                    />
                  </LocalizationProvider> */}
                </FormControl>
              </Grid>
              {/* {user.role === "Customer" || user.role === "Subcustomer" ? (
                <Grid item xs={12} md={12}>
                  <TextField
                    value={"support@vastedge.com"}
                    label="Assigned To"
                    required
                    fullWidth
                    name="assigned"
                    disabled
                    inputRef={register({
                      required: "Assigned to is required.",
                    })}
                    error={Boolean(errors.assigned)}
                    helperText={errors.assigned?.message}
                  /> */}
              {/* <TextField
                    value={"support@vastedge.com"}
                    label="Assigned To"
                    name="assigned"
                    onChange={onInputChange}
                    size="small"
                    // required
                    fullWidth
                    disabled
                  /> */}
              {/* </Grid>
              ) : ( */}
              <Grid item xs={12} md={6} sm={6}>
                <FormControl
                  fullWidth
                  error={Boolean(errors.assigned)}
                  required
                >
                  <InputLabel id="demo-simple-select-label">
                    Assigned To
                  </InputLabel>
                  <Controller
                    render={(props) => (
                      <Select
                        MenuProps={{ className: "select-box-height" }}
                        value={props.value}
                        label="Assigned To"
                        onChange={props.onChange}
                      >
                        {employeesList.map((e, i) => (
                          <MenuItem key={i} value={e.email}>
                            {e.email}
                          </MenuItem>
                        ))}
                      </Select>
                    )}
                    name="assigned"
                    control={control}
                    // defaultValue=""
                    rules={{
                      required: "Please select assigned to",
                    }}
                  />
                  <FormHelperText>{errors.assigned?.message}</FormHelperText>
                </FormControl>
              </Grid>
              {/* )} */}
              {user.role === "Customer" || user.role === "Subcustomer" ? (
                <></>
              ) : (
                <Grid item xs={12} md={6} sm={6}>
                  <FormControl fullWidth error={Boolean(errors.flag)}>
                    <InputLabel id="demo-simple-select-label">
                      Ticket
                    </InputLabel>
                    <Controller
                      render={(props) => (
                        <Select
                          value={props.value}
                          // value={
                          //   user.role === "Customer" ||
                          //   user.role === "Subcustomer"
                          //     ? "E"
                          //     : ""
                          // }
                          onChange={props.onChange}
                          disabled={
                            user.role === "Customer" ||
                            user.role === "Subcustomer"
                              ? true
                              : false
                          }
                        >
                          <MenuItem value={"E"}>External</MenuItem>
                          <MenuItem value={"I"}>Internal</MenuItem>
                        </Select>
                      )}
                      name="flag"
                      control={control}
                      rules={{
                        required: "Please select ticket type",
                      }}
                    />
                    <FormHelperText>{errors.flag?.message}</FormHelperText>
                  </FormControl>
                </Grid>
              )}

              <Grid item xs={12} md={12} sm={6}>
                <TextField
                  //  value={data.problem_description}
                  //  onChange={onInputChange}
                  name="problem_description"
                  label="Description"
                  required
                  fullWidth
                  multiline={true}
                  rows={3}
                  inputRef={register({
                    required: "Description is required.",
                  })}
                  error={Boolean(errors.problem_description)}
                  helperText={errors.problem_description?.message}
                />
                {/* <TextField
                  value={data.problem_description}
                  onChange={onInputChange}
                  label="Description"
                  required
                  fullWidth
                  multiline={true}
                  rows={3}
                  name="problem_description"
                /> */}
              </Grid>
            </Grid>
          </form>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              setOpen(false);
              setMinDate("");
              setMaxDate("");
            }}
            className="cancel-button"
          >
            Cancel
          </Button>
          <Button
            disabled={/^Trial_User$/i.test(user.role) ? true : false}
            onClick={handleSubmit(onNewTicketSubmit)}
            type="submit"
            className="blue-button"
          >
            Submit
          </Button>
        </DialogActions>
      </Box>
    </Dialog>
  );
}
function disablePrevDates(startDate) {
  const startSeconds = Date.parse(startDate);
  return (date) => {
    return Date.parse(date) < startSeconds;
  };
}
function getUpdatableData(data) {
  return {
    email: data.email,
    firstname: data.firstname,
    lastname: data.lastname,
    address: data.address,
    contact: data.contact,
    role: data.role,
    cost_rate: data.cost_rate,
    bill_rate: data.bill_rate,
  };
}
function createDateAsUTC(date) {
  return new Date(
    Date.UTC(
      date.getFullYear(),
      date.getMonth(),
      date.getDate(),
      date.getHours(),
      date.getMinutes(),
      date.getSeconds()
    )
  );
}
